/**
 * Constants for medical scribe streaming
 */
import { getDynamicWsUrl } from "utils/api-config.util";

// WebSocket configuration
export const MAX_WS_CONNECT_ATTEMPTS = 3;
export const WS_RETRY_BASE_DELAY_MS = 400;
export const EXISTING_SOCKET_CLOSE_TIMEOUT_MS = 1500;
export const WS_CONNECTION_TIMEOUT_MS = 5000;
export const MAX_RECONNECT_ATTEMPTS = 5;

// Audio configuration
export const AUDIO_SAMPLE_RATE = 16000;
export const AUDIO_CHANNEL_COUNT = 1;
/**
 * After `recording_started`, if no audio frames are sent within this window the
 * session is "phantom" (started but silent) — log a high-signal warning. See FE-5.
 */
export const PHANTOM_SESSION_WATCHDOG_MS = 5000;

// Timing — empirically tuned; prefer explicit WS buffer drain over fixed waits where possible
export const WS_READY_DELAY_MS = 100;
/** Delay after pause message so backend can process before UI finalizes */
export const PAUSE_MESSAGE_DELAY_MS = 300;
export const PAUSE_FLUSH_TIMEOUT_MS = 2000;
export const PAUSE_CHUNK_SAVE_TIMEOUT_MS = 3000;
export const PAUSE_WS_BUFFER_DRAIN_MS = 3000;
export const WS_SEND_BUFFER_DRAIN_MS = 5000;
/** Safety margin after buffer drain before pause/stop/end signals */
export const WS_POST_AUDIO_SAFETY_DELAY_MS = 500;
export const WAIT_FOR_ALL_CHUNKS_TIMEOUT_MS = 3000;
/** Max wait for in-flight background cleanup before Capture Visit / Resume proceeds */
export const BACKGROUND_CLEANUP_WAIT_MS = 3000;
export const END_RECORDING_WAIT_MS = 1000;
/** Delay after resume-before-end confirmation before sending end_recording */
export const RESUME_BEFORE_END_DELAY_MS = 200;
/** Max wait for recording_started when loading scribe before stop-from-paused */
export const RESUME_CONFIRMATION_TIMEOUT_MS = 3000;
export const STOP_SAVE_RECORDING_TIMEOUT_MS = 15000;
export const STOP_CLEANUP_TIMEOUT_MS = 20000;

/**
 * Get WebSocket URL from environment variables
 */
export const getWebSocketUrl = (): string => {
  const base = getDynamicWsUrl();
  const normalized = base.endsWith("/") ? base.slice(0, -1) : base;
  return `${normalized}/ambient-scribe/`;
};
